import {Observable} from 'rxjs';
import { Injectable, Component} from '@angular/core';
import { BackendService } from '../backend/backend.service';
import { InternetService } from '../internet/internet.service';
import { RoutesTable } from '../../resources/routes-table.model';
import { DefaultResponse } from '../../models/form/DefaultResponse';

@Injectable()
export class StocksService {

    private minRangeResult: number = 9;
    private maxRangeResult: number = 200;
    private timeRangeToUpdateIntervalMapper = {
        '1' : 1000, //intervalo de hora, atualizaão a cada segundo
        '24': 1000, //intervalo de dia, atualizaão a cada segundo
        '168': 1000 * 60,
        '720': 1000 * 9999,
        '1440': 1000 * 9999,
        '8640': 1000 * 9999,
        '43200': 1000 * 1000 * 1000
    };
    private _randomDataIndexIncrement: number = 1;

    constructor(
        private backendService: BackendService
    ){

    }
    /** Define as extremidades da variação
     * @param min Stop
     * @param max Gain
    */
    public setExtrems(min: number, max: number){

        this.maxRangeResult = max;
        this.minRangeResult = min;
    }

    /* Gera um valor aleatório dentro dos limites definidos */
    public generateRandomValue(): number{
        let value = Math.random() * (this.maxRangeResult - this.minRangeResult) + this.minRangeResult;
        return + value.toFixed(2);
    }

    /** Iniciar acompanhamento
        @param stockId Identificador da ação que se deseja acompanhar,
        @param interval O intervalo de tempo que será mostrado no gráfico durante o monitoramento
    */
    startTracking(stockId: number, interval: number): Observable<object>{

        return new Observable( observer => {
            let values = this.getRandomValues(1)[0];
            observer.next({ y: values[1], x: values[0] });

            setInterval( () => {
                let values = this.getRandomValues(1)[0];
                observer.next({ y: values[1], x: values[0] });
            }, interval)
        });
    }

    /** Fornece uma lista de pontos aleatórios baseados em uma linha do tempo
     * @param length tamanho do array a ser gerado
    */
    getRandomValues(length: number): Array<Array<number>>{

        let points = [];
        for(let i = - length; i <= 0; i+=1){
            let time = (new Date()).getTime();
            time = time + this._randomDataIndexIncrement++ * 1000 * 1000;
            points.push([time, this.generateRandomValue()])
        }

        return points;
    }

    getIntervalIndex(interval: number){
        let index = 0;
        let numberKey = interval.toString();

        for(var key in this.timeRangeToUpdateIntervalMapper){
            if(key == numberKey)
                break;

            index++;
        }
        return index;
    }

    /** Total de Ações
    */
    getStocks(){
        return this.backendService.get('/assets/data/stocks.json');
    }
}
